import React from "react";
import PropTypes from "prop-types";

import { DefaultHeader, HeaderContent, Text } from "./style";
import Logo from "./logo";

export default function Header({ children, callToActionText }) {
  return (
    <DefaultHeader>
      <HeaderContent>
        <Logo />
        <div style={{ padding: "0px 20px" }}>
          {callToActionText && <Text size="16px">{callToActionText}</Text>}
        </div>
      </HeaderContent>
      <section
        style={{
          height: '80vh',
          display: 'flex',
          flexDirection: "column",
        }}
      >
        <div style={{ padding: "0px 20px" }}>{children}</div>
      </section>
    </DefaultHeader>
  );
}

Header.defaultProps = {
  children: null,
  callToActionText: null,
};

Header.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.node,
  callToActionText: PropTypes.string,
};
